import { render, staticRenderFns } from "./LayoutFrontFooter.vue?vue&type=template&id=32581e9a&scoped=true&"
import script from "./LayoutFrontFooter.vue?vue&type=script&lang=js&"
export * from "./LayoutFrontFooter.vue?vue&type=script&lang=js&"
import style0 from "./LayoutFrontFooter.vue?vue&type=style&index=0&id=32581e9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32581e9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32581e9a')) {
      api.createRecord('32581e9a', component.options)
    } else {
      api.reload('32581e9a', component.options)
    }
    module.hot.accept("./LayoutFrontFooter.vue?vue&type=template&id=32581e9a&scoped=true&", function () {
      api.rerender('32581e9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LayoutFrontFooter.vue"
export default component.exports